import { Pipe, PipeTransform } from '@angular/core';

/**
 * Simply transforms the type of the value to exclude `null`.
 * This only matters when `tsconfig.json.angularCompilerOptions.strictTemplates` is set to `true`.
 * Some pipes, like `async`, have `null` in their return types for some reason.
 * The Angular compiler will throw an error if you try to use a pipe like this
 * to pass a value to an input that doesn't expect `null`.
 * This pipe should have zero runtime behavior — its only purpose is to do this type cast.
 *
 * @usage
 * ```html
 * <!-- Throws an error at compile time because `AsyncPipe.transform` adds `null` to the value's type -->
 * <my-component [dataThatCannotBeNull]="someData$ | async">
 *
 * <!-- With `notNull`, no error. -->
 * <my-component [dataThatCannotBeNull]="someData$ | async | notNull">
 * ```
 */
@Pipe({ name: 'notNull' })
export class NotNullPipe implements PipeTransform {
    public transform<T extends any>(value: T): Exclude<T, null> {
        return value as Exclude<T, null>;
    }
}
